<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_VIEW_DATA')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết yêu cầu chứng từ</h1>
      <div class="btn-group float-right">
        <button
          @click="reqRD('Yêu cầu GDV bảo lãnh')"
          v-if="
            detailText.status === 'WAIT_OP_APPROVE' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_REQUEST_DIRECT_APPROVE')
          "
          class="f12 font-medium btn btn-outline-secondary"
        >
          Yêu cầu GDV bảo lãnh
        </button>

        <button @click="copyLink" class="f12 font-medium btn btn-outline-secondary">
          Copy link
        </button>
        <button
          @click="waitOP('Gửi duyệt'), updateFile"
          v-if="
            detailText.status === 'NO_PROVIDE' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_REQUSET_APPROVE_RE_APPROVE')
          "
          class="f12 font-medium btn btn-outline-secondary"
        >
          Gửi duyệt
        </button>

        <button
          @click="waitOP('Gửi duyệt lại'), updateFile"
          v-if="
            detailText.status === 'REJECT' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_REQUSET_APPROVE_RE_APPROVE')
          "
          class="f12 font-medium btn btn-outline-secondary"
        >
          Gửi duyệt lại
        </button>

        <button
          @click="waitRD('Gửi duyệt lại'), updateFile"
          v-if="
            detailText.status === 'DIRECTOR_REJECT' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_REQUSET_APPROVE_RE_APPROVE')
          "
          class="f12 font-medium btn btn-outline-secondary"
        >
          Gửi duyệt lại
        </button>

        <button
          @click="approveRD('GĐV bảo lãnh')"
          v-if="
            detailText.status === 'WAITE_DIRECTOR_APPROVE' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_DIRECT_APPROVE_REJECT')
          "
          class="f12 font-medium btn btn-outline-secondary"
        >
          GĐV bảo lãnh
        </button>

        <button
          @click="noteModal = true"
          v-if="
            detailText.status === 'WAITE_DIRECTOR_APPROVE' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_DIRECT_APPROVE_REJECT')
          "
          class="f12 font-medium btn btn-outline-danger"
        >
          GDV từ chối
        </button>

        <button
          @click="approveOP('Duyệt')"
          v-if="
            detailText.status === 'WAIT_OP_APPROVE' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_APPROVE_REJECT')
          "
          class="f12 font-medium btn btn-outline-success"
        >
          Duyệt
        </button>
        <button
          @click="noteModal = true"
          v-if="
            detailText.status === 'WAIT_OP_APPROVE' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_APPROVE_REJECT')
          "
          class="f12 font-medium btn btn-outline-danger"
        >
          Từ chối
        </button>

        <button
          v-if="
            detailText.status !== 'COMPLETE' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_ASSIGN_USER')
          "
          @click="$bvModal.show('assign-modal')"
          class="f12 font-medium btn btn-outline-secondary"
        >
          Gán NV xử lý
        </button>
        <button
          v-if="
            detailText.status !== 'COMPLETE' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_SELF_ASSIGN')
          "
          @click="assignToMe"
          class="f12 font-medium btn btn-outline-secondary"
        >
          Nhận việc
        </button>
        <button @click="checkStatus(id)" class="f12 font-medium btn btn-outline-secondary">
          Kiểm tra TT Thanh toán
        </button>
        <button
          @click="$router.push('/list-licence')"
          class="f12 font-medium btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>Thông tin Merchant</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên merchant<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.merchantInfo && detailText.merchantInfo.name }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Địa chỉ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.merchantInfo && detailText.merchantInfo.addressBiz }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Email<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.merchantInfo && detailText.merchantInfo.email }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số điện thoại<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.merchantInfo && detailText.merchantInfo.mobile }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Sale phát triển<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="detailText.saleInfo && detailText.saleInfo.name"
                >
                  <span>{{ detailText.saleInfo.name }}</span> -
                  <span> {{ detailText.saleInfo.email }}</span>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Nhân viên xử lý<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="detailText.assigneeInfo && detailText.assigneeInfo.name"
                >
                  <span>{{ detailText.assigneeInfo.name }}</span> -
                  <span> {{ detailText.assigneeInfo.email }}</span>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Điểm chấp nhận thanh toán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="detailText.merchantInfo && detailText.merchantInfo.bizArea"
                >
                  {{ detailText.merchantInfo.bizArea.join(', ') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái YCCCT<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span class="badge" :class="[detailText.status ? detailText.status : '']">
                    {{ detailText.status | transformData(optionLicenceStt) }}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin giao dịch MPOS</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã giao dịch MPOS<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.transInfo && detailText.transInfo.tranTxnId }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số tiền giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.transInfo && detailText.transInfo.amount | fomatCurrency }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Loại giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.transInfo && detailText.transInfo.tranTypeText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Phương thức thanh toán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.transInfo && detailText.transInfo.paymentMethodText }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái giao dịch<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                {{ detailText.transInfo && detailText.transInfo.statusText }}
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Loại rủi ro<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detailText.riskTypeText }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin thẻ thanh toán</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên chủ thẻ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.cardInfo && detailText.cardInfo.holderName }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số thẻ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.cardInfo && detailText.cardInfo.number }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Loại thẻ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detailText.cardInfo && detailText.cardInfo.type }}
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Lịch sử cập nhật yêu cầu thanh toán</h1>
            <div class="table-responsive">
              <table class="table table-hover table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th>Thời gian</th>
                    <th>Thao tác</th>
                    <th>Lý do</th>
                    <th>Người thực hiện</th>
                  </tr>
                </thead>
                <tbody v-for="(item, index) in detailAction" :key="index">
                  <tr>
                    <td>{{ item.actionAt }}</td>
                    <td>{{ item.actionName }}</td>
                    <td>{{ item.note }}</td>
                    <td>
                      {{ item.actionBy }}<br />
                      <span class="text-primary">{{ item.actionByEmail }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mb-3">
          <!-- <div class="mb-2 float-right">
            <b-button>Copy</b-button>
          </div> -->
          <div class="img-list-wrapper">
            <h1 class="form-inner-heading">Upload thông tin chứng từ</h1>
            <div>
              <div>
                <h1 class="form-inner-heading">1. Chứng từ liên quan đến giao dịch</h1>
                <i
                  >Hướng dẫn:
                  <ul class="b">
                    <li>
                      Nếu là giao dịch trực tiếp cần cung cấp: Hoá đơn bán lẻ, VAT, Phiếu thu, Phiếu
                      giao hàng, Phiếu xuất kho, Hợp đồng...
                    </li>
                    <li>
                      Nếu là giao dịch trực tuyến cần cung cấp: Hình ảnh tin nhắn, Sao kê trừ tiền,
                      File ghi âm, Mail trao đổi, Chứng từ xác nhận đã giao dịch, ...
                    </li>
                  </ul>
                </i>
                <br />
                <p>Upload file PDF, ghi âm, video, ...</p>
                <div class="form-group img-list">
                  <div
                    v-if="
                      detailText.status === 'NO_PROVIDE' ||
                      detailText.status === 'REJECT' ||
                      detailText.status === 'DIRECTOR_REJECT'
                    "
                  >
                    <input
                      accept=".pdf, audio/*, video/*"
                      class="input-file"
                      style="display: none"
                      id="file-trans"
                      @change="uploadFileTrans"
                      type="file"
                    />
                    <label
                      v-if="transFile.length < 4"
                      style="width: 30%"
                      tabindex="0"
                      for="file-trans"
                      class="btn btn-outline-secondary"
                      >Chọn file tải lên
                    </label>
                  </div>
                  <div
                    v-for="(item, index) in transFile"
                    :key="index"
                    style="background-color: #f5f5f5"
                  >
                    <div class="box-header">
                      <b class="text-primary">{{ item.name }}</b>
                      <span
                        v-if="
                          detailText.status === 'NO_PROVIDE' ||
                          detailText.status === 'REJECT' ||
                          detailText.status === 'DIRECTOR_REJECT'
                        "
                        @click="removeFile(index, transFile)"
                        class="float-right"
                        ><i class="bx bx-trash bx-sm"></i
                      ></span>
                    </div>
                  </div>
                </div>

                <p>Upload ảnh</p>
                <div class="form-group img-list">
                  <ul class="m-0" v-viewer>
                    <li v-for="(item, index) in imageTrans" :key="index">
                      <a href="#popup-slider" data-toggle="modal">
                        <img :src="item.name" />
                        <span
                          v-if="
                            detailText.status === 'NO_PROVIDE' ||
                            detailText.status === 'REJECT' ||
                            detailText.status === 'DIRECTOR_REJECT'
                          "
                          @click="removeFile(index, imageTrans)"
                        >
                          <i class="bx bx-trash bx-sm"></i>
                        </span>
                      </a>
                    </li>
                    <li>
                      <div
                        v-if="loadingImage"
                        class="add-img d-flex align-content-center justify-content-center"
                      >
                        <div class="text-center">
                          <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                        </div>
                      </div>
                      <div
                        v-else-if="
                          (detailText.status === 'NO_PROVIDE' ||
                            detailText.status === 'REJECT' ||
                            detailText.status === 'DIRECTOR_REJECT') &&
                          imageTrans.length < 10
                        "
                        class="add-img"
                      >
                        <span class="bx bx-plus text-center"></span>
                        <input
                          type="file"
                          ref="fileInput"
                          accept="image/jpeg, image/png"
                          @input="selectImageTrans"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <h1 class="form-inner-heading">2. Chứng từ liên quan đến thông tin chủ thẻ</h1>
                <i
                  >Các thông tin cần cung cấp: Ảnh hộ chiếu, CMND/CCCD (Chụp 2 mặt), Hình ảnh khách
                  hàng giao dịch tại đơn vị, Hình ảnh trích xuất camera khách giao dịch, Hình ảnh
                  khách hàng tại cửa hàng
                </i>
                <br />
                <p>Upload file PDF, ghi âm, video, ...</p>
                <div class="form-group img-list">
                  <div
                    v-if="
                      detailText.status === 'NO_PROVIDE' ||
                      detailText.status === 'REJECT' ||
                      detailText.status === 'DIRECTOR_REJECT'
                    "
                  >
                    <input
                      accept=".pdf, audio/*, video/*"
                      class="input-file"
                      style="display: none"
                      id="file-card"
                      @change="uploadFileCard"
                      type="file"
                    />
                    <label
                      v-if="cardFile.length < 4"
                      style="width: 30%"
                      tabindex="0"
                      for="file-card"
                      class="btn btn-outline-secondary"
                      >Chọn file tải lên
                    </label>
                  </div>
                  <div
                    v-for="(itemm, indexx) in cardFile"
                    :key="indexx"
                    style="background-color: #f5f5f5"
                  >
                    <div class="box-header">
                      <b class="text-primary">{{ itemm.name }}</b>
                      <span
                        v-if="
                          detailText.status === 'NO_PROVIDE' ||
                          detailText.status === 'REJECT' ||
                          detailText.status === 'DIRECTOR_REJECT'
                        "
                        @click="removeFile(indexx, cardFile)"
                        class="float-right"
                        ><i class="bx bx-trash bx-sm"></i
                      ></span>
                    </div>
                  </div>
                </div>
                <p>Upload ảnh</p>
                <div class="form-group img-list">
                  <ul class="m-0" v-viewer>
                    <li v-for="(item, index) in imageCard" :key="index">
                      <a href="#popup-slider" data-toggle="modal">
                        <img :src="item.name" />
                        <span
                          v-if="
                            detailText.status === 'NO_PROVIDE' ||
                            detailText.status === 'REJECT' ||
                            detailText.status === 'DIRECTOR_REJECT'
                          "
                          @click="removeFile(index, imageCard)"
                        >
                          <i class="bx bx-trash bx-sm"></i>
                        </span>
                      </a>
                    </li>
                    <li>
                      <div
                        v-if="loadingImage"
                        class="add-img d-flex align-content-center justify-content-center"
                      >
                        <div class="text-center">
                          <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                        </div>
                      </div>
                      <div
                        v-else-if="
                          detailText.status === 'NO_PROVIDE' ||
                          detailText.status === 'REJECT' ||
                          (detailText.status === 'DIRECTOR_REJECT' && imageCard.length < 10)
                        "
                        class="add-img"
                      >
                        <span class="bx bx-plus text-center"></span>
                        <input
                          type="file"
                          ref="imageCard"
                          accept="image/jpeg, image/png"
                          @input="selectImageCard"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <b-button
            variant="primary"
            @click="updateFile"
            v-if="
              detailText.status === 'NO_PROVIDE' ||
              detailText.status === 'REJECT' ||
              detailText.status === 'DIRECTOR_REJECT'
            "
            :disabled="
              transFile.length == 0 &&
              imageTrans.length == 0 &&
              cardFile.length == 0 &&
              imageCard.length == 0
            "
            >Lưu file
          </b-button>
        </div>
      </div>
    </div>

    <!-- Modal thông báo-->
    <b-modal :no-enforce-focus="true" id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
        <b-button variant="primary" @click="$router.push('/list-licence')" v-if="backList">
          Quay lại danh sách
        </b-button>
      </template>
    </b-modal>

    <!-- Modal từ chối-->
    <b-modal :no-enforce-focus="true" id="modal-scoped" v-model="noteModal">
      <template #modal-header="{}">
        <h5>Lý do từ chối</h5>
        <b-button variant="light" @click="(noteModal = false), (reasonReject = '')">x</b-button>
      </template>
      <div class="text-center m-3">
        <ValidationObserver ref="formReject">
          <form @submit.prevent="updateStatus('REJECT')">
            <ValidationProvider
              rules="required|minMaxName_4"
              vid="reasonReject"
              name="Lý do từ chối"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <input v-model="reasonReject" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
      <template #modal-footer="{}">
        <b-button variant="light" @click="(noteModal = false), (reasonReject = '')"> Huỷ </b-button>
        <b-button
          v-if="
            detailText.status === 'WAIT_OP_APPROVE' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_APPROVE_REJECT')
          "
          variant="primary"
          @click="rejectOP('Từ chối')"
        >
          Đồng ý
        </b-button>
        <b-button
          v-if="
            detailText.status === 'WAITE_DIRECTOR_APPROVE' &&
            dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_DIRECT_APPROVE_REJECT')
          "
          variant="primary"
          @click="rejectRD('GĐV từ chối')"
        >
          Đồng ý
        </b-button>
      </template>
    </b-modal>
    <!--gán nhân viên-->
    <b-modal :no-enforce-focus="true" id="assign-modal">
      <template #modal-header="{ close }">
        <h5>Gán nhân viên xử lý</h5>
        <b-button size="sm" variant="outline-light" @click="close()">x</b-button>
      </template>

      <template #default="{}">
        <div class="form-group row">
          <div class="col-sm-12">
            <b-input-group>
              <b-form-input
                placeholder="Tên/Email"
                v-model="searchSale.textSearch"
                @input="listStaff"
                @keyup.enter="listStaff"
              >
              </b-form-input>
              <b-input-group-append>
                <b-button variant="outline-secondary">Tìm kiếm</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <div class="table-responsive m-3" style="max-height: 50vh; overflow-y: auto">
            <b-table
              hover
              :items="dataSale"
              :fields="fields"
              :sticky-header="true"
              selectable
              select-mode="single"
              @row-selected="onStaffSelected"
              id="table-sale"
              :per-page="searchSale.limit"
              :current-page="searchSale.page"
              small
            >
            </b-table>
          </div>
          <b-pagination
            class="ml-3"
            v-model="searchSale.page"
            :total-rows="total"
            :per-page="searchSale.limit"
            aria-controls="table-sale"
          ></b-pagination>
        </div>
      </template>

      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="primary" @click="assignToSale" :disabled="idAssign === ''">
          Xác nhận
        </b-button>
        <b-button size="sm" variant="light" @click="cancel()"> Huỷ </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { LicenceService } from '@/services/licence.service'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'

  import 'vue-loading-overlay/dist/vue-loading.css'
  import prepareQueryParamsMixin from '@/mixins/prepareQueryParamsMixin'
  import Config from '@/thirdParty/config'

  export default {
    data() {
      return {
        loading: false,
        id: this.$route.params.id,
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        detailText: {},
        detailAction: [],
        transFile: [],
        imageTrans: [],

        cardFile: [],
        imageCard: [],
        loadingImage: false,
        noteModal: false,
        reasonReject: '',
        submitTotalUrl: {
          licenceId: this.$route.params.id,
        },
        options: {
          defaultWidth: '100%',
          defaultHeight: '100%',
        },
        style: {
          width: '100%',
        },
        dataSale: [],
        fields: [
          {
            label: 'Tên',
            key: 'name',
            thStyle: { 'min-width': '140px', 'word-break': 'break-word' },
          },
          { label: 'Email', key: 'userName' },
          { label: 'Tỉnh/Thành phố', key: 'provinceName' },
        ],
        idAssign: '',
        searchSale: {
          limit: 20,
          page: 1,
          userId: JSON.parse(localStorage.getItem('userData')).userId,
        },
        total: 0,
        backList: false,
        optionLicenceStt: Config.licenceStt,
      }
    },

    created() {
      this.fetchData()
      this.listStaff()
    },
    components: {},
    watch: {
      'searchSale.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.listStaff()
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.searchSale.limit,
          page: this.searchSale.page,
        })
      },
    },
    mixins: [prepareQueryParamsMixin],
    methods: {
      async checkStatus(id) {
        try {
          this.loading = true
          const response = await LicenceService.checkStatus(id)
          this.showSuccessMx(`Trạng thái thông tin: ${response.data.statusText}`)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async waitOP(act) {
        try {
          this.loading = true
          await this.updateFile()
          const data = await LicenceService.waitOP({
            licenceId: this.id,
            actionName: act,
          })
          if (data.success) {
            this.successModal('Thành công')
            await this.fetchData()
            this.backList = true
          } else {
            this.errorModal(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async reqRD(act) {
        try {
          this.loading = true
          const data = await LicenceService.reqRD({
            licenceId: this.id,
            actionName: act,
          })
          if (data.success) {
            this.successModal('Thành công')
            await this.fetchData()
            this.backList = true
          } else {
            this.errorModal(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async waitRD(act) {
        try {
          this.loading = true
          await this.updateFile()
          const data = await LicenceService.waitRD({
            licenceId: this.id,
            actionName: act,
          })
          if (data.success) {
            this.successModal('Thành công')
            await this.fetchData()
            this.backList = true
          } else {
            this.errorModal(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async approveRD(act) {
        try {
          this.loading = true
          await this.updateFile()
          const data = await LicenceService.approveRD({
            licenceId: this.id,
            actionName: act,
          })
          if (data.success) {
            this.successModal('Thành công')
            await this.fetchData()
            this.backList = true
          } else {
            this.errorModal(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async approveOP(act) {
        try {
          this.loading = true
          const data = await LicenceService.approveOP({
            licenceId: this.id,
            actionName: act,
          })
          if (data.success) {
            this.successModal('Thành công')
            await this.fetchData()
            this.backList = true
          } else {
            this.errorModal(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async rejectOP(act) {
        try {
          const isSuccess = await this.$refs.formReject.validate()
          if (!isSuccess) {
            return
          }
          this.noteModal = false
          const data = await LicenceService.rejectOP({
            licenceId: this.id,
            note: this.reasonReject,
            actionName: act,
          })
          if (data.success) {
            this.successModal('Thành công')
            await this.fetchData()
            this.reasonReject = ''
          } else {
            this.reasonReject = ''
            this.errorModal(data.message)
          }
        } catch (e) {
          console.log(e)
        }
      },
      async rejectRD(act) {
        try {
          const isSuccess = await this.$refs.formReject.validate()
          if (!isSuccess) {
            return
          }
          this.noteModal = false
          const data = await LicenceService.rejectRD({
            licenceId: this.id,
            note: this.reasonReject,
            actionName: act,
          })
          if (data.success) {
            this.successModal('Thành công')
            await this.fetchData()
            this.reasonReject = ''
          } else {
            this.reasonReject = ''
            this.errorModal(data.message)
          }
        } catch (e) {
          console.log(e)
        }
      },
      onStaffSelected(item) {
        this.idAssign = item.length > 0 ? item[0].userId : ''
      },
      async listStaff() {
        try {
          const data = await StaffService.getListLowerGrade(this.searchSale)
          if (data.success) {
            this.total = data.data.length
            this.dataSale = data.data
          }
        } catch (error) {
          console.log(error)
        }
      },
      async assignToSale() {
        try {
          this.$bvModal.hide('assign-modal')
          this.loading = true
          const data = await LicenceService.assignSale({
            licenceIds: [this.id],
            userId: this.idAssign,
            isSelfAssign: false,
          })
          if (data.success) {
            this.successModal('Gán nhân viên xử lý thành công')
            await this.fetchData()
            this.backList = true
          } else {
            this.errorModal(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async assignToMe() {
        try {
          this.loading = true
          const data = await LicenceService.assignSelf({
            licenceIds: [this.id],
            userId: this.searchSale.userId,
            isSelfAssign: true,
          })
          if (data.success) {
            this.successModal('Nhận việc thành công')
            await this.fetchData()
            this.backList = true
          } else {
            this.errorModal(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async totalSubmit() {
        await this.submitFile(this.transFile)
        this.submitTotalUrl.licenceTransactionUrls = this.transFile.map(e => e.url)
        await this.submitFile(this.imageTrans)
        this.submitTotalUrl.licenceTransactionUrlsImg = this.imageTrans.map(e => e.url)
        await this.submitFile(this.cardFile)
        this.submitTotalUrl.licenceCardOwnerUrls = this.cardFile.map(e => e.url)
        await this.submitFile(this.imageCard)
        this.submitTotalUrl.licenceCardOwnerUrlsImg = this.imageCard.map(e => e.url)
      },
      async updateFile() {
        try {
          this.loading = true
          await this.totalSubmit()
          const data = await LicenceService.updateUrl(this.submitTotalUrl)
          if (data.success) {
            this.successModal('Lưu file thành công')
            await this.fetchData()
          } else {
            this.errorModal(data.message)
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      },
      async submitFile(arr) {
        try {
          this.loading = true
          for (const i in arr) {
            if (arr[i].file) {
              const formData = new FormData()
              formData.append('file', arr[i].file)
              const data = await LicenceService.uploadFile(formData)
              if (data.success) {
                arr[i].url = data.data.urlFile
              }
            }
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      },
      async fetchData() {
        try {
          this.loading = true
          const data = await LicenceService.detailLicence({
            licenceId: this.id,
          })
          if (data.success) {
            this.detailText = data.data.licence
            this.detailAction = data.data.actionHistory
            this.transFile = data.data.licence.licenceTransactionUrls
              ? data.data.licence.licenceTransactionUrls.map(e => {
                  return {
                    name: e,
                    url: e,
                  }
                })
              : []
            this.imageTrans = data.data.licence.licenceTransactionUrlsImg
              ? data.data.licence.licenceTransactionUrlsImg.map(e => {
                  return {
                    name: e,
                    url: e,
                  }
                })
              : []
            this.cardFile = data.data.licence.licenceCardOwnerUrls
              ? data.data.licence.licenceCardOwnerUrls.map(e => {
                  return {
                    name: e,
                    url: e,
                  }
                })
              : []
            this.imageCard = data.data.licence.licenceCardOwnerUrlsImg
              ? data.data.licence.licenceCardOwnerUrlsImg.map(e => {
                  return {
                    name: e,
                    url: e,
                  }
                })
              : []
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async uploadFileTrans(file) {
        const fileData = file.target.files[0]
        if (fileData.size > 20 * 1024 * 1024) {
          alert('Upload tối đa 20MB')
          return
        }
        this.transFile.push({
          name: fileData.name,
          file: fileData,
        })
      },
      async uploadFileCard(file) {
        const fileData = file.target.files[0]
        if (fileData.size > 20 * 1024 * 1024) {
          alert('File tối đa 20MB')
          return
        }
        this.cardFile.push({
          name: fileData.name,
          file: fileData,
        })
        // this.formData.append('file', fileData)
      },
      removeFile(id, arr) {
        return arr.splice(id, 1)
      },

      async selectImageTrans() {
        const input = this.$refs.fileInput
        const files = input.files
        // this.formData.append('file', files[0])
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {
            this.imageTrans.push({
              name: e.target.result,
              file: files[0],
            })
          }
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
      },
      async selectImageCard() {
        const input = this.$refs.imageCard
        const files = input.files
        // this.formData.append('file', files[0])
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {
            console.log(e)
            this.imageCard.push({
              name: e.target.result,
              file: files[0],
            })
          }
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
      },
      copyLink() {
        navigator.clipboard.writeText(
          `${window._env_?.VUE_APP_BASE_URL ?? process.env.VUE_APP_BASE_URL}/mc-ccct/${this.id}`
        )
        this.successModal('Copy link thành công')
      },

      successModal(msg) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = msg
      },
      errorModal(msg) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = msg
      },
    },
  }
</script>
<style scoped>
  ul.b {
    list-style-type: square !important;
  }
</style>
